<script setup>
const props = defineProps({
  image: Object,
});
</script>

<template>
  <div class="mb-xl last:mb-0">
    <picture v-if="image">
      <source
        v-if="image.type !== 'svg' && image?.url?.webp"
        :srcset="image?.url?.webp"
        type="image/webp"
      />
      <source
        v-if="image.type !== 'svg' && image.type !== 'png' && image?.url?.jpg"
        :srcset="image?.url?.jpg"
        type="image/jpeg"
      />
      <img
        v-if="image.type === 'jpg' && image?.url?.jpg"
        class="block w-full"
        :src="image?.url?.jpg"
        :alt="image?.alt"
        :title="image?.title"
      />
      <img
        v-else-if="image.type === 'png' && image?.url?.png"
        class="block w-full"
        :src="image?.url?.png"
        :alt="image?.alt"
        :title="image?.title"
      />
      <img
        v-else
        class="block w-full"
        :src="image?.url?.original"
        :alt="image?.alt"
        :title="image?.title"
      />
    </picture>
  </div>
</template>

<style></style>
